import { LOAD_PREFERENCES, LOAD_PREFERENCES_ERROR, LOAD_PREFERENCES_SUCCESS } from "../Types/preferences.constants";

const INITIAL_STATE = {
    loading: false,
    notificationPreferences: {},
    error: null,
}

export const preferencesReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case LOAD_PREFERENCES:
            return { ...state, loading: true, notificationPreferences: {} };
        case LOAD_PREFERENCES_SUCCESS:
            return {
                ...state,
                loading: false,
                notificationPreferences: action.payload.notificationPreferences,
            };
        case LOAD_PREFERENCES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}